import { _ as z } from "./extends-hS2Bh-Yp.js";
import * as p from "react";
import pr, { createContext as br, PureComponent as hr } from "react";
import { P as Se, p as v } from "./index-DQMInta3.js";
import { c as ee, a as yr, u as gr } from "./medium-JVtzoF2c.js";
import { _ as Fr } from "./inheritsLoose-A8WKSWDx.js";
function Er(e, r) {
  if (e == null) return {};
  var n = {};
  for (var t in e) if ({}.hasOwnProperty.call(e, t)) {
    if (r.includes(t)) continue;
    n[t] = e[t];
  }
  return n;
}
var J = "data-focus-lock", Ie = "data-focus-lock-disabled", Or = "data-no-focus-lock", xr = "data-autofocus-inside", wr = "data-no-autofocus", $ = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
};
process.env.NODE_ENV !== "production" && Se.node;
var Ne = ee({}, function(e) {
  var r = e.target, n = e.currentTarget;
  return {
    target: r,
    currentTarget: n
  };
}), Te = ee(), Sr = ee(), Ir = yr({
  async: !0,
  ssr: typeof document < "u"
}), Nr = /* @__PURE__ */ br(void 0), Tr = [], re = /* @__PURE__ */ p.forwardRef(function(r, n) {
  var t, o = p.useState(), u = o[0], a = o[1], c = p.useRef(), h = p.useRef(!1), i = p.useRef(null), m = p.useState({}), f = m[1], d = r.children, b = r.disabled, s = b === void 0 ? !1 : b, l = r.noFocusGuards, y = l === void 0 ? !1 : l, F = r.persistentFocus, g = F === void 0 ? !1 : F, O = r.crossFrame, W = O === void 0 ? !0 : O, k = r.autoFocus, Ye = k === void 0 ? !0 : k, ze = r.allowTextSelection, Je = r.group, Qe = r.className, Xe = r.whiteList, Ze = r.hasPositiveIndices, le = r.shards, H = le === void 0 ? Tr : le, ve = r.as, me = ve === void 0 ? "div" : ve, pe = r.lockProps, er = pe === void 0 ? {} : pe, rr = r.sideCar, be = r.returnFocus, U = be === void 0 ? !1 : be, nr = r.focusOptions, V = r.onActivation, j = r.onDeactivation, tr = p.useState({}), or = tr[0], ur = p.useCallback(function(x) {
    var N = x.captureFocusRestore;
    if (!i.current) {
      var T, w = (T = document) == null ? void 0 : T.activeElement;
      i.current = w, w !== document.body && (i.current = N(w));
    }
    c.current && V && V(c.current), h.current = !0, f();
  }, [V]), ar = p.useCallback(function() {
    h.current = !1, j && j(c.current), f();
  }, [j]), ir = p.useCallback(function(x) {
    var N = i.current;
    if (N) {
      var T = (typeof N == "function" ? N() : N) || document.body, w = typeof U == "function" ? U(T) : U;
      if (w) {
        var ye = typeof w == "object" ? w : void 0;
        i.current = null, x ? Promise.resolve().then(function() {
          return T.focus(ye);
        }) : T.focus(ye);
      }
    }
  }, [U]), cr = p.useCallback(function(x) {
    h.current && Ne.useMedium(x);
  }, []), fr = Te.useMedium, sr = p.useCallback(function(x) {
    c.current !== x && (c.current = x, a(x));
  }, []);
  process.env.NODE_ENV !== "production" && (typeof ze < "u" && console.warn("React-Focus-Lock: allowTextSelection is deprecated and enabled by default"), p.useEffect(function() {
    !c.current && typeof me != "string" && console.error("FocusLock: could not obtain ref to internal node");
  }, []));
  var dr = z((t = {}, t[Ie] = s && "disabled", t[J] = Je, t), er), he = y !== !0, lr = he && y !== "tail", vr = gr([n, sr]), mr = p.useMemo(function() {
    return {
      observed: c,
      shards: H,
      enabled: !s,
      active: h.current
    };
  }, [s, h.current, H, u]);
  return /* @__PURE__ */ p.createElement(p.Fragment, null, he && [
    /* @__PURE__ */ p.createElement("div", {
      key: "guard-first",
      "data-focus-guard": !0,
      tabIndex: s ? -1 : 0,
      style: $
    }),
    Ze ? /* @__PURE__ */ p.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": !0,
      tabIndex: s ? -1 : 1,
      style: $
    }) : null
  ], !s && /* @__PURE__ */ p.createElement(rr, {
    id: or,
    sideCar: Ir,
    observed: u,
    disabled: s,
    persistentFocus: g,
    crossFrame: W,
    autoFocus: Ye,
    whiteList: Xe,
    shards: H,
    onActivation: ur,
    onDeactivation: ar,
    returnFocus: ir,
    focusOptions: nr
  }), /* @__PURE__ */ p.createElement(me, z({
    ref: vr
  }, dr, {
    className: Qe,
    onBlur: fr,
    onFocus: cr
  }), /* @__PURE__ */ p.createElement(Nr.Provider, {
    value: mr
  }, d)), lr && /* @__PURE__ */ p.createElement("div", {
    "data-focus-guard": !0,
    tabIndex: s ? -1 : 0,
    style: $
  }));
});
re.propTypes = process.env.NODE_ENV !== "production" ? {
  children: v.node,
  disabled: v.bool,
  returnFocus: v.oneOfType([v.bool, v.object, v.func]),
  focusOptions: v.object,
  noFocusGuards: v.bool,
  hasPositiveIndices: v.bool,
  allowTextSelection: v.bool,
  autoFocus: v.bool,
  persistentFocus: v.bool,
  crossFrame: v.bool,
  group: v.string,
  className: v.string,
  whiteList: v.func,
  shards: v.arrayOf(v.any),
  as: v.oneOfType([v.string, v.func, v.object]),
  lockProps: v.object,
  onActivation: v.func,
  onDeactivation: v.func,
  sideCar: v.any.isRequired
} : {};
function M(e) {
  "@babel/helpers - typeof";
  return M = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, M(e);
}
function Pr(e, r) {
  if (M(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var t = n.call(e, r || "default");
    if (M(t) != "object") return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function Ar(e) {
  var r = Pr(e, "string");
  return M(r) == "symbol" ? r : r + "";
}
function Dr(e, r, n) {
  return (r = Ar(r)) in e ? Object.defineProperty(e, r, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = n, e;
}
function Cr(e, r) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof e != "function")
      throw new Error("Expected reducePropsToState to be a function.");
    if (typeof r != "function")
      throw new Error("Expected handleStateChangeOnClient to be a function.");
  }
  function n(t) {
    return t.displayName || t.name || "Component";
  }
  return function(o) {
    if (process.env.NODE_ENV !== "production" && typeof o != "function")
      throw new Error("Expected WrappedComponent to be a React component.");
    var u = [], a;
    function c() {
      a = e(u.map(function(i) {
        return i.props;
      })), r(a);
    }
    var h = /* @__PURE__ */ function(i) {
      Fr(m, i);
      function m() {
        return i.apply(this, arguments) || this;
      }
      m.peek = function() {
        return a;
      };
      var f = m.prototype;
      return f.componentDidMount = function() {
        u.push(this), c();
      }, f.componentDidUpdate = function() {
        c();
      }, f.componentWillUnmount = function() {
        var b = u.indexOf(this);
        u.splice(b, 1), c();
      }, f.render = function() {
        return /* @__PURE__ */ pr.createElement(o, this.props);
      }, m;
    }(hr);
    return Dr(h, "displayName", "SideEffect(" + n(o) + ")"), h;
  };
}
var E = function(e) {
  for (var r = Array(e.length), n = 0; n < e.length; ++n)
    r[n] = e[n];
  return r;
}, I = function(e) {
  return Array.isArray(e) ? e : [e];
}, Pe = function(e) {
  return Array.isArray(e) ? e[0] : e;
}, kr = function(e) {
  if (e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  var r = window.getComputedStyle(e, null);
  return !r || !r.getPropertyValue ? !1 : r.getPropertyValue("display") === "none" || r.getPropertyValue("visibility") === "hidden";
}, Ae = function(e) {
  return e.parentNode && e.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e.parentNode.host
  ) : e.parentNode;
}, De = function(e) {
  return e === document || e && e.nodeType === Node.DOCUMENT_NODE;
}, _r = function(e) {
  return e.hasAttribute("inert");
}, Mr = function(e, r) {
  return !e || De(e) || !kr(e) && !_r(e) && r(Ae(e));
}, Ce = function(e, r) {
  var n = e.get(r);
  if (n !== void 0)
    return n;
  var t = Mr(r, Ce.bind(void 0, e));
  return e.set(r, t), t;
}, Lr = function(e, r) {
  return e && !De(e) ? Ur(e) ? r(Ae(e)) : !1 : !0;
}, ke = function(e, r) {
  var n = e.get(r);
  if (n !== void 0)
    return n;
  var t = Lr(r, ke.bind(void 0, e));
  return e.set(r, t), t;
}, _e = function(e) {
  return e.dataset;
}, Rr = function(e) {
  return e.tagName === "BUTTON";
}, Me = function(e) {
  return e.tagName === "INPUT";
}, Le = function(e) {
  return Me(e) && e.type === "radio";
}, Wr = function(e) {
  return !((Me(e) || Rr(e)) && (e.type === "hidden" || e.disabled));
}, Ur = function(e) {
  var r = e.getAttribute(wr);
  return ![!0, "true", ""].includes(r);
}, ne = function(e) {
  var r;
  return !!(e && (!((r = _e(e)) === null || r === void 0) && r.focusGuard));
}, Q = function(e) {
  return !ne(e);
}, Br = function(e) {
  return !!e;
}, Gr = function(e, r) {
  var n = Math.max(0, e.tabIndex), t = Math.max(0, r.tabIndex), o = n - t, u = e.index - r.index;
  if (o) {
    if (!n)
      return 1;
    if (!t)
      return -1;
  }
  return o || u;
}, Hr = function(e) {
  return e.tabIndex < 0 && !e.hasAttribute("tabindex") ? 0 : e.tabIndex;
}, te = function(e, r, n) {
  return E(e).map(function(t, o) {
    var u = Hr(t);
    return {
      node: t,
      index: o,
      tabIndex: n && u === -1 ? (t.dataset || {}).focusGuard ? 0 : -1 : u
    };
  }).filter(function(t) {
    return !r || t.tabIndex >= 0;
  }).sort(Gr);
}, Vr = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  // elements with explicit roles will also use explicit tabindex
  // '[role="button"]',
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
], oe = Vr.join(","), jr = "".concat(oe, ", [data-focus-guard]"), Re = function(e, r) {
  return E((e.shadowRoot || e).children).reduce(function(n, t) {
    return n.concat(t.matches(r ? jr : oe) ? [t] : [], Re(t));
  }, []);
}, $r = function(e, r) {
  var n;
  return e instanceof HTMLIFrameElement && (!((n = e.contentDocument) === null || n === void 0) && n.body) ? C([e.contentDocument.body], r) : [e];
}, C = function(e, r) {
  return e.reduce(function(n, t) {
    var o, u = Re(t, r), a = (o = []).concat.apply(o, u.map(function(c) {
      return $r(c, r);
    }));
    return n.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      a,
      // add if node is tabbable itself
      t.parentNode ? E(t.parentNode.querySelectorAll(oe)).filter(function(c) {
        return c === t;
      }) : []
    );
  }, []);
}, qr = function(e) {
  var r = e.querySelectorAll("[".concat(xr, "]"));
  return E(r).map(function(n) {
    return C([n]);
  }).reduce(function(n, t) {
    return n.concat(t);
  }, []);
}, ue = function(e, r) {
  return E(e).filter(function(n) {
    return Ce(r, n);
  }).filter(function(n) {
    return Wr(n);
  });
}, ge = function(e, r) {
  return r === void 0 && (r = /* @__PURE__ */ new Map()), E(e).filter(function(n) {
    return ke(r, n);
  });
}, ae = function(e, r, n) {
  return te(ue(C(e, n), r), !0, n);
}, B = function(e, r) {
  return te(ue(C(e), r), !1);
}, Kr = function(e, r) {
  return ue(qr(e), r);
}, S = function(e, r) {
  return e.shadowRoot ? S(e.shadowRoot, r) : Object.getPrototypeOf(e).contains !== void 0 && Object.getPrototypeOf(e).contains.call(e, r) ? !0 : E(e.children).some(function(n) {
    var t;
    if (n instanceof HTMLIFrameElement) {
      var o = (t = n.contentDocument) === null || t === void 0 ? void 0 : t.body;
      return o ? S(o, r) : !1;
    }
    return S(n, r);
  });
}, Yr = function(e) {
  for (var r = /* @__PURE__ */ new Set(), n = e.length, t = 0; t < n; t += 1)
    for (var o = t + 1; o < n; o += 1) {
      var u = e[t].compareDocumentPosition(e[o]);
      (u & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && r.add(o), (u & Node.DOCUMENT_POSITION_CONTAINS) > 0 && r.add(t);
    }
  return e.filter(function(a, c) {
    return !r.has(c);
  });
}, We = function(e) {
  return e.parentNode ? We(e.parentNode) : e;
}, ie = function(e) {
  var r = I(e);
  return r.filter(Boolean).reduce(function(n, t) {
    var o = t.getAttribute(J);
    return n.push.apply(n, o ? Yr(E(We(t).querySelectorAll("[".concat(J, '="').concat(o, '"]:not([').concat(Ie, '="disabled"])')))) : [t]), n;
  }, []);
}, zr = function(e) {
  try {
    return e();
  } catch {
    return;
  }
}, L = function(e) {
  if (e === void 0 && (e = document), !(!e || !e.activeElement)) {
    var r = e.activeElement;
    return r.shadowRoot ? L(r.shadowRoot) : r instanceof HTMLIFrameElement && zr(function() {
      return r.contentWindow.document;
    }) ? L(r.contentWindow.document) : r;
  }
}, Jr = function(e, r) {
  return e === r;
}, Qr = function(e, r) {
  return !!E(e.querySelectorAll("iframe")).some(function(n) {
    return Jr(n, r);
  });
}, Ue = function(e, r) {
  return r === void 0 && (r = L(Pe(e).ownerDocument)), !r || r.dataset && r.dataset.focusGuard ? !1 : ie(e).some(function(n) {
    return S(n, r) || Qr(n, r);
  });
}, Xr = function(e) {
  e === void 0 && (e = document);
  var r = L(e);
  return r ? E(e.querySelectorAll("[".concat(Or, "]"))).some(function(n) {
    return S(n, r);
  }) : !1;
}, Zr = function(e, r) {
  return r.filter(Le).filter(function(n) {
    return n.name === e.name;
  }).filter(function(n) {
    return n.checked;
  })[0] || e;
}, ce = function(e, r) {
  return Le(e) && e.name ? Zr(e, r) : e;
}, en = function(e) {
  var r = /* @__PURE__ */ new Set();
  return e.forEach(function(n) {
    return r.add(ce(n, e));
  }), e.filter(function(n) {
    return r.has(n);
  });
}, Fe = function(e) {
  return e[0] && e.length > 1 ? ce(e[0], e) : e[0];
}, Ee = function(e, r) {
  return e.indexOf(ce(r, e));
}, X = "NEW_FOCUS", rn = function(e, r, n, t, o) {
  var u = e.length, a = e[0], c = e[u - 1], h = ne(t);
  if (!(t && e.indexOf(t) >= 0)) {
    var i = t !== void 0 ? n.indexOf(t) : -1, m = o ? n.indexOf(o) : i, f = o ? e.indexOf(o) : -1;
    if (i === -1)
      return f !== -1 ? f : X;
    if (f === -1)
      return X;
    var d = i - m, b = n.indexOf(a), s = n.indexOf(c), l = en(n), y = t !== void 0 ? l.indexOf(t) : -1, F = y - (o ? l.indexOf(o) : i);
    if (!d && f >= 0 || r.length === 0)
      return f;
    var g = Ee(e, r[0]), O = Ee(e, r[r.length - 1]);
    if (i <= b && h && Math.abs(d) > 1)
      return O;
    if (i >= s && h && Math.abs(d) > 1)
      return g;
    if (d && Math.abs(F) > 1)
      return f;
    if (i <= b)
      return O;
    if (i > s)
      return g;
    if (d)
      return Math.abs(d) > 1 ? f : (u + f + d) % u;
  }
}, nn = function(e) {
  return function(r) {
    var n, t = (n = _e(r)) === null || n === void 0 ? void 0 : n.autofocus;
    return (
      // @ts-expect-error
      r.autofocus || //
      t !== void 0 && t !== "false" || //
      e.indexOf(r) >= 0
    );
  };
}, Oe = function(e, r, n) {
  var t = e.map(function(u) {
    var a = u.node;
    return a;
  }), o = ge(t.filter(nn(n)));
  return o && o.length ? Fe(o) : Fe(ge(r));
}, Z = function(e, r) {
  return r === void 0 && (r = []), r.push(e), e.parentNode && Z(e.parentNode.host || e.parentNode, r), r;
}, q = function(e, r) {
  for (var n = Z(e), t = Z(r), o = 0; o < n.length; o += 1) {
    var u = n[o];
    if (t.indexOf(u) >= 0)
      return u;
  }
  return !1;
}, Be = function(e, r, n) {
  var t = I(e), o = I(r), u = t[0], a = !1;
  return o.filter(Boolean).forEach(function(c) {
    a = q(a || c, c) || a, n.filter(Boolean).forEach(function(h) {
      var i = q(u, h);
      i && (!a || S(i, a) ? a = i : a = q(i, a));
    });
  }), a;
}, xe = function(e, r) {
  return e.reduce(function(n, t) {
    return n.concat(Kr(t, r));
  }, []);
}, tn = function(e, r) {
  var n = /* @__PURE__ */ new Map();
  return r.forEach(function(t) {
    return n.set(t.node, t);
  }), e.map(function(t) {
    return n.get(t);
  }).filter(Br);
}, on = function(e, r) {
  var n = L(I(e).length > 0 ? document : Pe(e).ownerDocument), t = ie(e).filter(Q), o = Be(n || e, e, t), u = /* @__PURE__ */ new Map(), a = B(t, u), c = a.filter(function(s) {
    var l = s.node;
    return Q(l);
  });
  if (c[0]) {
    var h = B([o], u).map(function(s) {
      var l = s.node;
      return l;
    }), i = tn(h, c), m = i.map(function(s) {
      var l = s.node;
      return l;
    }), f = i.filter(function(s) {
      var l = s.tabIndex;
      return l >= 0;
    }).map(function(s) {
      var l = s.node;
      return l;
    }), d = rn(m, f, h, n, r);
    if (d === X) {
      var b = (
        // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        Oe(a, f, xe(t, u)) || Oe(a, m, xe(t, u))
      );
      if (b)
        return { node: b };
      console.warn("focus-lock: cannot find any node to move focus into");
      return;
    }
    return d === void 0 ? d : i[d];
  }
}, un = function(e) {
  var r = ie(e).filter(Q), n = Be(e, e, r), t = te(C([n], !0), !0, !0), o = C(r, !1);
  return t.map(function(u) {
    var a = u.node, c = u.index;
    return {
      node: a,
      index: c,
      lockItem: o.indexOf(a) >= 0,
      guard: ne(a)
    };
  });
}, fe = function(e, r) {
  e && ("focus" in e && e.focus(r), "contentWindow" in e && e.contentWindow && e.contentWindow.focus());
}, K = 0, Y = !1, Ge = function(e, r, n) {
  n === void 0 && (n = {});
  var t = on(e, r);
  if (!Y && t) {
    if (K > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), Y = !0, setTimeout(function() {
        Y = !1;
      }, 1);
      return;
    }
    K++, fe(t.node, n.focusOptions), K--;
  }
};
function _(e) {
  if (!e)
    return null;
  if (typeof WeakRef > "u")
    return function() {
      return e || null;
    };
  var r = e ? new WeakRef(e) : null;
  return function() {
    return (r == null ? void 0 : r.deref()) || null;
  };
}
var an = function(e) {
  if (!e)
    return null;
  for (var r = [], n = e; n && n !== document.body; )
    r.push({
      current: _(n),
      parent: _(n.parentElement),
      left: _(n.previousElementSibling),
      right: _(n.nextElementSibling)
    }), n = n.parentElement;
  return {
    element: _(e),
    stack: r,
    ownerDocument: e.ownerDocument
  };
}, cn = function(e) {
  var r, n, t, o, u;
  if (e)
    for (var a = e.stack, c = e.ownerDocument, h = /* @__PURE__ */ new Map(), i = 0, m = a; i < m.length; i++) {
      var f = m[i], d = (r = f.parent) === null || r === void 0 ? void 0 : r.call(f);
      if (d && c.contains(d)) {
        for (var b = (n = f.left) === null || n === void 0 ? void 0 : n.call(f), s = f.current(), l = d.contains(s) ? s : void 0, y = (t = f.right) === null || t === void 0 ? void 0 : t.call(f), F = ae([d], h), g = (
          // that is element itself
          (u = (o = l ?? // or something in it's place
          (b == null ? void 0 : b.nextElementSibling)) !== null && o !== void 0 ? o : (
            // or somebody to the right, still close enough
            y
          )) !== null && u !== void 0 ? u : (
            // or somebody to the left, something?
            b
          )
        ); g; ) {
          for (var O = 0, W = F; O < W.length; O++) {
            var k = W[O];
            if (g != null && g.contains(k.node))
              return k.node;
          }
          g = g.nextElementSibling;
        }
        if (F.length)
          return F[0].node;
      }
    }
}, fn = function(e) {
  var r = an(e);
  return function() {
    return cn(r);
  };
}, sn = function(e, r, n) {
  if (!e || !r)
    return console.error("no element or scope given"), {};
  var t = I(r);
  if (t.every(function(a) {
    return !S(a, e);
  }))
    return console.error("Active element is not contained in the scope"), {};
  var o = n ? ae(t, /* @__PURE__ */ new Map()) : B(t, /* @__PURE__ */ new Map()), u = o.findIndex(function(a) {
    var c = a.node;
    return c === e;
  });
  if (u !== -1)
    return {
      prev: o[u - 1],
      next: o[u + 1],
      first: o[0],
      last: o[o.length - 1]
    };
}, dn = function(e, r) {
  var n = r ? ae(I(e), /* @__PURE__ */ new Map()) : B(I(e), /* @__PURE__ */ new Map());
  return {
    first: n[0],
    last: n[n.length - 1]
  };
}, ln = function(e) {
  return Object.assign({
    scope: document.body,
    cycle: !0,
    onlyTabbable: !0
  }, e);
}, He = function(e, r, n) {
  r === void 0 && (r = {});
  var t = ln(r), o = sn(e, t.scope, t.onlyTabbable);
  if (o) {
    var u = n(o, t.cycle);
    u && fe(u.node, t.focusOptions);
  }
}, vn = function(e, r) {
  r === void 0 && (r = {}), He(e, r, function(n, t) {
    var o = n.next, u = n.first;
    return o || t && u;
  });
}, mn = function(e, r) {
  r === void 0 && (r = {}), He(e, r, function(n, t) {
    var o = n.prev, u = n.last;
    return o || t && u;
  });
}, Ve = function(e, r, n) {
  var t, o = dn(e, (t = r.onlyTabbable) !== null && t !== void 0 ? t : !0), u = o[n];
  u && fe(u.node, r.focusOptions);
}, pn = function(e, r) {
  r === void 0 && (r = {}), Ve(e, r, "first");
}, bn = function(e, r) {
  r === void 0 && (r = {}), Ve(e, r, "last");
};
function se(e) {
  setTimeout(e, 1);
}
var hn = function(r) {
  return r && "current" in r ? r.current : r;
}, yn = function() {
  return document && document.activeElement === document.body;
}, gn = function() {
  return yn() || Xr();
}, A = null, P = null, D = null, R = !1, Fn = function() {
  return !0;
}, En = function(r) {
  return (A.whiteList || Fn)(r);
}, On = function(r, n) {
  D = {
    observerNode: r,
    portaledElement: n
  };
}, xn = function(r) {
  return D && D.portaledElement === r;
};
function we(e, r, n, t) {
  var o = null, u = e;
  do {
    var a = t[u];
    if (a.guard)
      a.node.dataset.focusAutoGuard && (o = a);
    else if (a.lockItem) {
      if (u !== e)
        return;
      o = null;
    } else
      break;
  } while ((u += n) !== r);
  o && (o.node.tabIndex = 0);
}
var wn = function(r) {
  return r ? !!R : R === "meanwhile";
}, Sn = function e(r, n, t) {
  return n && (n.host === r && (!n.activeElement || t.contains(n.activeElement)) || n.parentNode && e(r, n.parentNode, t));
}, In = function(r, n) {
  return n.some(function(t) {
    return Sn(r, t, t);
  });
}, G = function() {
  var r = !1;
  if (A) {
    var n = A, t = n.observed, o = n.persistentFocus, u = n.autoFocus, a = n.shards, c = n.crossFrame, h = n.focusOptions, i = t || D && D.portaledElement, m = document && document.activeElement;
    if (i) {
      var f = [i].concat(a.map(hn).filter(Boolean));
      if ((!m || En(m)) && (o || wn(c) || !gn() || !P && u) && (i && !(Ue(f) || m && In(m, f) || xn(m)) && (document && !P && m && !u ? (m.blur && m.blur(), document.body.focus()) : (r = Ge(f, P, {
        focusOptions: h
      }), D = {})), R = !1, P = document && document.activeElement), document && m !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
        var d = document && document.activeElement, b = un(f), s = b.map(function(l) {
          var y = l.node;
          return y;
        }).indexOf(d);
        s > -1 && (b.filter(function(l) {
          var y = l.guard, F = l.node;
          return y && F.dataset.focusAutoGuard;
        }).forEach(function(l) {
          var y = l.node;
          return y.removeAttribute("tabIndex");
        }), we(s, b.length, 1, b), we(s, -1, -1, b));
      }
    }
  }
  return r;
}, je = function(r) {
  G() && r && (r.stopPropagation(), r.preventDefault());
}, de = function() {
  return se(G);
}, Nn = function(r) {
  var n = r.target, t = r.currentTarget;
  t.contains(n) || On(t, n);
}, Tn = function() {
  return null;
};
process.env.NODE_ENV !== "production" && Se.node.isRequired;
var $e = function() {
  R = "just", se(function() {
    R = "meanwhile";
  });
}, Pn = function() {
  document.addEventListener("focusin", je), document.addEventListener("focusout", de), window.addEventListener("blur", $e);
}, An = function() {
  document.removeEventListener("focusin", je), document.removeEventListener("focusout", de), window.removeEventListener("blur", $e);
};
function Dn(e) {
  return e.filter(function(r) {
    var n = r.disabled;
    return !n;
  });
}
var qe = {
  moveFocusInside: Ge,
  focusInside: Ue,
  focusNextElement: vn,
  focusPrevElement: mn,
  focusFirstElement: pn,
  focusLastElement: bn,
  captureFocusRestore: fn
};
function Cn(e) {
  var r = e.slice(-1)[0];
  r && !A && Pn();
  var n = A, t = n && r && r.id === n.id;
  A = r, n && !t && (n.onDeactivation(), e.filter(function(o) {
    var u = o.id;
    return u === n.id;
  }).length || n.returnFocus(!r)), r ? (P = null, (!t || n.observed !== r.observed) && r.onActivation(qe), G(), se(G)) : (An(), P = null);
}
Ne.assignSyncMedium(Nn);
Te.assignMedium(de);
Sr.assignMedium(function(e) {
  return e(qe);
});
const kn = Cr(Dn, Cn)(Tn);
var _n = /* @__PURE__ */ p.forwardRef(function(r, n) {
  return /* @__PURE__ */ p.createElement(re, z({
    sideCar: kn,
    ref: n
  }, r));
}), Ke = re.propTypes || {};
Ke.sideCar;
var Mn = Er(Ke, ["sideCar"]);
_n.propTypes = process.env.NODE_ENV !== "production" ? Mn : {};
export {
  _n as F
};
